import { buildMatchableItemsCfn, matchesRequiredSku } from './build-matchable-items.cfn';
import { PromotionalSku } from '../promotional-sku.class';
import { PromotionalItemData } from '../data/promotion-sku-assets.class';
import { PromotionalSkus } from '../promotional-skus.class';

export const addSkuCfn = (promotionalSkus: PromotionalSkus, sku: string): PromotionalSku => {
	const skuAsset = PromotionalItemData.findBySku(sku) ?? null;
	if (skuAsset === null) return null;

	const promotionalSku = new PromotionalSku({ dataIn: { sku }, parent: promotionalSkus });

	// check if any requiredSku matches items in the kitchen (OR logic)
	const { requiredSkus } = promotionalSku;
	const { kitchen } = promotionalSku.refMap;
	if (requiredSkus && requiredSkus.length > 0 && kitchen) {
		const allItems = buildMatchableItemsCfn(kitchen);
		const hasMatch = requiredSkus.some((rs) => allItems.some((item) => matchesRequiredSku(item, rs)));
		if (!hasMatch) return null;
	}

	// is there already one.  If so, can we add another
	if (!promotionalSku.allowMultiple && promotionalSkus.findBySku(sku)) return null;

	return promotionalSku;
};
